"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelManagementLink = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_messages_1 = require("@tableau/catalog-messages");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
function LabelManagementLink() {
    const siteUrls = (0, catalog_core_1.useSiteUrls)();
    return (react_1.default.createElement(widgets_1.TextLinkWidget, { href: siteUrls.labelsUrl(), testId: '-label-management', target: '_blank', rel: 'noopener noreferrer', kind: widgets_1.TextLinkKind.Standalone }, catalog_messages_1.Messages.labelManagementLink()));
}
exports.LabelManagementLink = LabelManagementLink;
//# sourceMappingURL=LabelManagement.js.map